// extracted by mini-css-extract-plugin
export default {"root":"search_root__EVNpC","input":"search_input__hz+KF","button":"search_button__h-Ljt"};